export interface AlbumModel {
  id: string;
  images: AlbumImage[];
  total_tracks: number;
}

export interface AlbumImage {
  height: number;
  url: string;
  width: number;
}
